import { useEffect, useState } from "react";
import { Download, DownloadCloud, Loader2 } from "lucide-react";
import { getSocialAssets, socialDownloadUrl, socialDownloadAllUrl } from "../../lib/api";

export function SocialView() {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSocialAssets()
      .then((d) => setAssets(Array.isArray(d) ? d : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 lg:p-12 max-w-5xl" data-testid="social-view">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-2">
        <div>
          <h2 className="font-serif-display text-3xl text-[#E8E2D2]">Kit Social</h2>
          <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40 mt-1">
            Grafiche pronte in stile Ghibli col Vecchio Cinghiale — post quadrati (1:1) e storie verticali (9:16)
          </p>
        </div>
        <a
          href={socialDownloadAllUrl()}
          className="inline-flex items-center gap-2 bg-[#D47738] text-[#0D110D] px-6 py-3 font-mono-accent text-xs uppercase tracking-[0.2em] hover:bg-[#E8E2D2] transition-colors"
          data-testid="download-all-social-btn"
        >
          <DownloadCloud className="w-4 h-4" /> Scarica tutte (ZIP)
        </a>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-[#E8E2D2]/40 font-mono-accent text-xs uppercase tracking-widest mt-10">
          <Loader2 className="w-4 h-4 animate-spin" /> Caricamento…
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
          {assets.map((a) => (
            <div key={a.slug} className="border border-white/15 bg-[#141A14] flex flex-col" data-testid={`social-asset-${a.slug}`}>
              <div className="aspect-[3/4] bg-[#0D110D] overflow-hidden">
                <img src={a.url} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div className="p-3 flex flex-col gap-2 flex-1">
                <p className="font-serif-display text-base text-[#E8E2D2] leading-tight">{a.title}</p>
                <span className="font-mono-accent text-[9px] uppercase tracking-widest text-[#D47738]">{a.format}</span>
                <a
                  href={socialDownloadUrl(a.slug)}
                  className="mt-auto inline-flex items-center justify-center gap-2 border border-white/20 py-2.5 font-mono-accent text-[10px] uppercase tracking-[0.15em] text-[#E8E2D2] hover:bg-[#D47738] hover:text-[#0D110D] hover:border-[#D47738] transition-colors"
                  data-testid={`download-social-${a.slug}`}
                >
                  <Download className="w-3.5 h-3.5" /> Scarica
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
